import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useResponsesStore } from '../../../stores/responsesStore'

import AddResponseKey from './AddResponseKey/AddResponseKey'
import ResponseNavItem from './ResponseNavItem/ResponseNavItem'

import styles from './responses-nav.module.scss'

function ResponsesNav() {
    const { t } = useTranslation()

    const [{ responses, isKeyAdding }] = useResponsesStore()

    const responsesRef = useRef(null)

    return (
        <nav className={styles.responsesNav}>
            <div className={styles.responsesNav__results}>
                {responses.length} {t('results')}
            </div>
            {isKeyAdding && <AddResponseKey />}
            <div className={styles.responsesNav__responses} ref={responsesRef}>
                {responses.map((response) => (
                    <ResponseNavItem
                        key={response.name}
                        response={response}
                        responsesRef={responsesRef}
                    />
                ))}
            </div>
        </nav>
    )
}

export default ResponsesNav
